import { ForYouState, ForyouQuestion } from "./index";
import { RootState } from "./store";
import commonservice from "@apis/commonservice";
import { useAppDispatch, useAppSelector } from "@hooks/redux";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Option } from "@store/configurations/types";
import { useEffect } from "react";

const initialState: ForYouState = {
  fetchVideoLoading: "loading",
  fetchLiveLoading: "loading",
  videoPageNo: 1,
  livePageNo: 1,
  pageSize: 12,
  hotvideoList: [],
  hotliveList: [],
  learnVideoId: null,
  // CMS配置
  configReady: false,
  foryouQuestion: [],
  homeLiveNumbers: [],
  homeVideoNumbers: [],
  CardStatus: "idle",
};

export const fetchForyouConfig = createAsyncThunk("focus/fetchForyouConfig", async () => {
  const reqData = ["foryou.question", "home.filter.live_numbers", "home.filter.video_numbers"];
  const data = await commonservice.fetchConfigs<{
    "foryou.question": ForyouQuestion[];
    "home.filter.live_numbers": Option[];
    "home.filter.video_numbers": Option[];
  }>({ reqData });
  return data;
});

export const foryouSlice = createSlice({
  name: "foryou",
  initialState,
  reducers: {
    updateVideoPageNo: (state, action: PayloadAction<number>) => {
      state.videoPageNo = action.payload;
    },
    updateLivePageNo: (state, action: PayloadAction<number>) => {
      state.livePageNo = action.payload;
    },
    updateLearnVideoId: (state, action: PayloadAction<string | number | null>) => {
      state.learnVideoId = action.payload as any;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchForyouConfig.fulfilled, (state, action) => {
      const data = action.payload;
      if (data) {
        state.foryouQuestion = data["foryou.question"] || [];
        state.homeLiveNumbers = data["home.filter.live_numbers"] || [];
        state.homeVideoNumbers = data["home.filter.video_numbers"] || [];
      }
      state.configReady = true;
    });
  },
});

export const { updateVideoPageNo, updateLivePageNo, updateLearnVideoId } = foryouSlice.actions;

export const selectPageForyouReady = (state: RootState) => {
  return state.foryouReducer.configReady;
};

const foryouReducer = foryouSlice.reducer;
export default foryouReducer;

export const useForyouQuestion = () => {
  const dispatch = useAppDispatch();
  let { foryouQuestion } = useAppSelector((state) => state.foryouReducer);
  useEffect(() => {
    if (foryouQuestion.length === 0) {
      dispatch(fetchForyouConfig());
    }
  }, []);
  return { foryouQuestion };
};
